import React from 'react';
import MFDRoomCard from './MFDRoomCard';
import mfdData from "./mfdData.json";
import MDFScreens from './MDFScreens/MDFScreens';


interface MFDRoomTabContentProps {
    selectedTab: string;
    selectedCrackScreen: string | null;
    setSelectedCrackScreen: React.Dispatch<React.SetStateAction<string | null>>;
}

const MFDRoomTabContent: React.FC<MFDRoomTabContentProps> = ({ selectedTab,selectedCrackScreen, setSelectedCrackScreen }) => {
    return (
        <>
            {selectedCrackScreen ? (<>
                <MDFScreens selectedCrackScreen={selectedCrackScreen} setSelectedCrackScreen={setSelectedCrackScreen}/>
            </>) : (<>
                <div className="grid grid-cols-3 gap-2 ">
                    {mfdData.acs.map((item: any) => (
                        <MFDRoomCard key={item.label} label={item.label} rows={item.rows} setSelectedCrackScreen={setSelectedCrackScreen} />
                    ))}

                </div>

            </>)}
            <div className="flex justify-end">

                <h3 className={`text-[26px] fixed ${selectedCrackScreen ? "right-5": "left-[58%]"} bottom-4 font-bold uppercase`}>{selectedTab}</h3>
            </div>
        </>);
};

export default MFDRoomTabContent;